<script setup lang="ts">
import { useElementVisibility } from '@vueuse/core';
import { MaybeRefOrGetter, toValue } from 'vue';

import RevealMobileFilters from '@/components/search/widgets/RevealMobileFilters.vue';

const props = defineProps<{
  hitsContainer?: MaybeRefOrGetter<HTMLElement>;
  primaryFiltersButton?: MaybeRefOrGetter<HTMLElement>;
}>();

defineEmits<{
  'show-filters': [];
}>();

const primaryFiltersButtonVisible = useElementVisibility(() => toValue(props.primaryFiltersButton));
const hitsContainerVisible = useElementVisibility(() => toValue(props.hitsContainer));
</script>

<template>
  <RevealMobileFilters
    :class="{ shown: !primaryFiltersButtonVisible && hitsContainerVisible }"
    isAbbreviated
    @open-filters="$emit('show-filters')"
  />
</template>
